// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cardContainer {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
  border: 1px solid #DCDFE1;
  border-radius: 0.5rem;
  box-shadow: none;
}
.cardContainer > * img {
  border-radius: 0.5rem;
}

.cardContainer:hover {
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
}

.actionFlexColumn {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/components/Card/PurchasesCard/purchases.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,aAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;AACF;AACE;EACE,qBAAA;AACJ;;AAGA;EACE,sCAAA;AAAF;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AADF","sourcesContent":[".cardContainer {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1rem;\n  border: 1px solid #DCDFE1;\n  border-radius: 0.5rem;\n  box-shadow: none;\n\n  > * img {\n    border-radius: 0.5rem;\n  }\n}\n\n.cardContainer:hover {\n  box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);\n}\n\n\n.actionFlexColumn{\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
